import clsx from 'clsx';

const Divider = ({ children, className }: { children?: React.ReactNode; className?: string }) => (
    <div className={clsx('flex w-full items-center', className)} data-testid="divider-wrapper">
        <span className="h-1 max-h-px flex-1 bg-icoGray-300 dark:bg-icoDarkMode-beton" />
        {children ? <span className="px-m text-xs">{children}</span> : null}
        <span className="h-1 max-h-px flex-1 bg-icoGray-300 dark:bg-icoDarkMode-beton" />
    </div>
);

Divider.displayName = 'Divider';
export default Divider;
